import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getParentPatientRequest, getStudiesRequest } from "../../../../redux/modules/report/slice";
import PatientInfo from "../patientInfo";
import { Box, Button, Card, Grid, Typography, IconButton, Tooltip } from "@mui/material";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const DicomViewer = ({ itemData, setShowComponent }) => {
  const dispatch = useDispatch();
  let { loading } = useSelector(state => state.report);

  // OHIF viewer URL
  const ohifViewerUrl = process.env.REACT_APP_OHIF_VIEWER_URL || 'http://localhost:3001';

  const getViewerUrl = (studyUID) => {
    return `${ohifViewerUrl}/viewer?StudyInstanceUIDs=${studyUID}`;
  };

  useEffect(() => {
    if (!itemData?.parentPatientResError && !itemData?.studyData?.orthancStudyInstanceUID) {
      if (!itemData?.seletedpatient?.orthancParentPatientId) {
        dispatch(getParentPatientRequest({
          patientID: itemData?.seletedpatient?._id,
          orthancPatientId: itemData?.seletedpatient?.orthancPatientId,
          orderId: itemData?.orderId
        }));
      } else {
        dispatch(getStudiesRequest({ orthancParentPatientId: itemData?.seletedpatient?.orthancParentPatientId, orderId: itemData?.orderId }));
      }
    }
  }, [dispatch, itemData?.studyData?.orthancStudyInstanceUID, itemData?.orderId]);

  const handleFullscreen = () => {
    const iframe = document.getElementById('ohif-viewer-iframe');
    if (iframe) {
      if (iframe.requestFullscreen) {
        iframe.requestFullscreen();
      } else if (iframe.webkitRequestFullscreen) {
        iframe.webkitRequestFullscreen();
      }
    }
  };

  return (
    <>
      {itemData?.seletedpatient && <PatientInfo patient={itemData?.seletedpatient} />}
      {loading && <Typography sx={{ color: "primary.dark", fontSize: { xs: '18px', sm: '24px', md: '30px' }, fontWeight: "600", textAlign: "center" }}>Fetching Data please wait...</Typography>}
      {itemData?.parentPatientResError && <Typography sx={{ color: "primary.dark", fontSize: { xs: '16px', sm: '20px', md: '30px' }, fontWeight: "600", textAlign: "center" }}>{itemData?.parentPatientResError}</Typography>}

      {itemData.studyData?.orthancStudyInstanceUID &&
        <>
          <Box mt={2} mb={2} display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} gap={2}>
            <Button
              component="a"
              href={getViewerUrl(itemData?.studyData?.orthancStudyInstanceUID)}
              target="_blank"
              className='commonBtn'
              variant="contained"
              disabled={loading}
              startIcon={<OpenInNewIcon />}
              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
            >
              {loading ? "loading..." : "Open in New Tab"}
            </Button>
            <Button
              onClick={() => { setShowComponent("createReport") }}
              className='commonBtn'
              variant="contained"
              disabled={loading}
              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
            >
              {loading ? "loading..." : "Create Report"}
            </Button>
            <Tooltip title="Fullscreen">
              <IconButton onClick={handleFullscreen} color="primary" sx={{ alignSelf: { xs: 'flex-end', sm: 'auto' } }}>
                <FullscreenIcon />
              </IconButton>
            </Tooltip>
          </Box>

          <Card className='cardStyle' sx={{ marginTop: "20px", marginBottom: "20px" }}>
            <Typography className='title'>Study Detail</Typography>
            <Grid container spacing={2}>
              <Grid item sm={3} xs={6}>
                <Typography color="text.secondary">Study Description</Typography>
                <Typography>{itemData?.studyData?.orthancStudyDescription || "-"}</Typography>
              </Grid>
              <Grid item sm={3} xs={6}>
                <Typography color="text.secondary">Accession Number</Typography>
                <Typography>{itemData?.orderId || "-"}</Typography>
              </Grid>
              <Grid item sm={3} xs={6}>
                <Typography color="text.secondary">Study Date</Typography>
                <Typography>{itemData?.studyData?.studyDate || "-"}</Typography>
              </Grid>
              <Grid item sm={3} xs={6}>
                <Typography color="text.secondary">Modality</Typography>
                <Typography>{itemData?.studyData?.modality || "US"}</Typography>
              </Grid>
            </Grid>
          </Card>

          <Box sx={{ position: 'relative', width: '100%', height: { xs: '60vh', sm: '70vh', md: '80vh' }, bgcolor: '#000', borderRadius: 2, overflow: 'hidden' }}>
            <iframe
              id="ohif-viewer-iframe"
              title="DICOM Viewer"
              style={{ width: "100%", height: "100%", border: 'none' }}
              src={getViewerUrl(itemData?.studyData?.orthancStudyInstanceUID)}
              allow="fullscreen"
              allowFullScreen
            />
          </Box>
        </>
      }
    </>
  );
};

export default DicomViewer;